module.exports = __webpack_public_path__ + "static/clients-image-2-ab74fab5759f476b045f4f7ea3d6ca30.png";